import { Alerts } from "../../../../utils/Alerts.js";
import { DateTime as DateTime$1 } from "../../../../components/DateTime/index.js";
import { UserName } from "../../../Users/shared/UserName.js";
import { useLocation } from "../../hooks/useLocation.js";
import { IdLabel } from "../../../../components/IdLabel/index.js";
import { LocationName } from "../LocationName.js";
import { DownloadPdfButton } from "../../../../components/Buttons/index.js";
import { useDownloadsApiServiceContext } from "../../../../contexts/DownloadsApiServiceContext.js";
import { useCurrentUserAnPCheck } from "../../../AuthWrapper2/hooks/useCurrentUserAnPCheck.js";
import { useLocationLogEntry } from "../../hooks/useLocationLogEntry.js";
import { LocationLogEntryFieldsDisplayRenderer } from "./LocationLogEntryFieldsDisplayRenderer.js";
import { PickLocationLogEntryRefsModal } from "./PickLocationLogEntryRefsModal.js";
import dayjs from "dayjs";
import { useState } from "react";
import { ContainerDimensionsContextProvider, Icon, Loading, Modal, toastManager } from "@therms/atalaya";
import { Fragment as Fragment$1, jsx, jsxs } from "react/jsx-runtime";
import { downloadBase64AsPdf, humanizeMinutes } from "@therms/web-js";
import { MdRefresh } from "react-icons/md";
//#region src/modules/Locations/shared/LocationLogEntries/LocationLogEntryModal.tsx
function LocationLogEntryModal({ closeHandler, entryId }) {
	const { client } = useDownloadsApiServiceContext();
	const [isPickingRefs, setIsPickingRefs] = useState(false);
	const { data: entryData, loading } = useLocationLogEntry({ entryId }, { cacheStrategy: "cache-first" });
	const { data: locationData } = useLocation(entryData ? { locationId: entryData.entry.locationId } : void 0, { fire: !!entryData });
	const canDownloadAndExportData = useCurrentUserAnPCheck(({ anp }) => anp.role.ops.access.canDownloadAndExportData);
	const handleDownloadLocationLogEntryPDF = (entryToDownload, refOptions) => {
		if (!canDownloadAndExportData) return;
		const toastId = Alerts.info(/* @__PURE__ */ jsxs("div", { children: [/* @__PURE__ */ jsx(Icon, {
			Icon: MdRefresh,
			spin: true
		}), " Starting download, please wait..."] }), {
			autoClose: false,
			position: "top-center"
		});
		client.locations.DownloadLocationLogEntry({ body: {
			entryId: entryToDownload.id,
			showEventsRefs: refOptions.showEventsRefs,
			showGpsCoords: refOptions.showGpsCoords,
			showInternalContent: refOptions.showEventsRefs,
			showLocationsRefs: refOptions.showLocationsRefs,
			showLogEntriesRefs: refOptions.showLogEntriesRefs,
			showRecordsRefs: refOptions.showRecordsRefs,
			showReportsRefs: refOptions.showReportsRefs,
			showUsersRefs: refOptions.showUsersRefs
		} }, { timeout: 6e4 }).then((response) => {
			const result = response;
			if (result.pdfBase64) downloadBase64AsPdf(`${locationData?.location.name} Log Entry - ${entryToDownload.entryType.name} - ${dayjs(entryToDownload.timestamp).format()} ${entryToDownload.title} ${entryToDownload.subTitle}`, result.pdfBase64);
		}).catch((err) => {
			console.error("err downloading entry", err);
		}).finally(() => toastManager.dismiss(toastId));
	};
	if (!entryData && loading) return /* @__PURE__ */ jsx(Loading, { overlay: true });
	if (!entryData?.entry) {
		Alerts.error("There was a problem loading the Log Entry");
		closeHandler();
	}
	const entry = entryData?.entry;
	return /* @__PURE__ */ jsxs(Fragment$1, { children: [/* @__PURE__ */ jsxs(Modal, {
		escPressClose: true,
		header: !!entry && /* @__PURE__ */ jsxs("div", {
			className: "inline-flex w-full items-center justify-between",
			children: [/* @__PURE__ */ jsx("span", {
				className: "text-lg font-bold",
				children: /* @__PURE__ */ jsx(LocationName, { locationId: entry.locationId })
			}), /* @__PURE__ */ jsx("div", { children: canDownloadAndExportData && /* @__PURE__ */ jsx("div", {
				className: "flex justify-end",
				children: /* @__PURE__ */ jsx("div", {
					className: "bg-surface-subtle p-xxs flex rounded",
					children: canDownloadAndExportData && /* @__PURE__ */ jsx(DownloadPdfButton, {
						size: "sm",
						onClick: () => setIsPickingRefs(true)
					})
				})
			}) })]
		}),
		closeHandler,
		children: [/* @__PURE__ */ jsxs("div", {
			className: "mx-base mt-xxs flex flex-wrap justify-between",
			children: [/* @__PURE__ */ jsxs("div", {
				className: "gap-x-xs flex flex-wrap items-baseline",
				children: [
					/* @__PURE__ */ jsx(IdLabel, {
						idLabel: entry?.idLabel,
						className: "traking-wide text-color-subtle text-base font-bold"
					}),
					/* @__PURE__ */ jsx("div", {
						className: "font-bold",
						children: entry?.title
					}),
					/* @__PURE__ */ jsx("div", {
						className: "text-color-subtle",
						children: entry?.subTitle
					})
				]
			}), /* @__PURE__ */ jsxs("div", {
				className: "gap-x-xs flex flex-wrap justify-between",
				children: [/* @__PURE__ */ jsx("div", {
					className: "text-color-subtle",
					children: /* @__PURE__ */ jsx(UserName, { user: entry?.createdByUser })
				}), /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsxs("div", {
					className: "font-medium",
					children: [/* @__PURE__ */ jsx(DateTime$1, {
						mode: "datetime",
						timestamp: entry?.timestamp
					}), entry?.timestampEnd && entry.timestamp !== entry?.timestampEnd && /* @__PURE__ */ jsxs(Fragment$1, { children: [
						" ",
						"- ",
						/* @__PURE__ */ jsx(DateTime$1, {
							mode: "time",
							timestamp: entry.timestampEnd
						}),
						!!entry.timeDurationMin && /* @__PURE__ */ jsxs("span", {
							className: "ml-xxs font-light",
							children: [
								"(",
								humanizeMinutes(entry.timeDurationMin),
								")"
							]
						})
					] })]
				}) })]
			})]
		}), /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsx(ContainerDimensionsContextProvider, { children: /* @__PURE__ */ jsx("div", {
			className: "p-sm",
			children: entry?.formInput && /* @__PURE__ */ jsx(LocationLogEntryFieldsDisplayRenderer, {
				formId: entry?.formInput.formId,
				valuesByFieldId: entry?.formInput?.fields
			})
		}) }) })]
	}), isPickingRefs && entry && /* @__PURE__ */ jsx(PickLocationLogEntryRefsModal, {
		closeHandler: () => setIsPickingRefs(false),
		onDownload: (refOptions) => {
			handleDownloadLocationLogEntryPDF(entry, refOptions);
		}
	})] });
}
//#endregion
export { LocationLogEntryModal };

//# sourceMappingURL=LocationLogEntryModal.js.map